import { SearchResult } from '../services/api';

export const isResolvedVideoTitle = (
  videoId: string,
  title: string | undefined | null,
): boolean => {
  if (!title) {
    return false;
  }
  return title !== videoId;
};

export const collectInlineVideoTitles = (
  segments: SearchResult[],
): Record<string, string> => {
  const inlineTitles: Record<string, string> = {};
  segments.forEach((segment) => {
    if (!segment.video_id || !isResolvedVideoTitle(segment.video_id, segment.video_name)) {
      return;
    }
    inlineTitles[segment.video_id] = segment.video_name as string;
  });
  return inlineTitles;
};

export const collectMissingVideoTitleIds = (
  segments: SearchResult[],
  knownTitles: Record<string, string>,
): string[] => {
  const missingVideoIds = new Set<string>();
  segments.forEach((segment) => {
    if (!segment.video_id) {
      return;
    }
    if (isResolvedVideoTitle(segment.video_id, segment.video_name)) {
      return;
    }
    if (Object.prototype.hasOwnProperty.call(knownTitles, segment.video_id)) {
      return;
    }
    missingVideoIds.add(segment.video_id);
  });
  return Array.from(missingVideoIds);
};
